<template>
    <div class="preview-dialog">
        <div class="preview-title">{{previewList[pointerIndex].name}}</div>
        <div class="preview-operate-btn">
            <el-button class="btn" style="background: #2d73cf;" @click="handleDownload">下 载</el-button>
            <el-button class="btn" style="background: #000;" @click="handleClose">关 闭</el-button>
        </div>
        <video-player
            v-if="previewList[pointerIndex].type.indexOf('video/')>-1"
            class="video-player vjs-custom-skin"
            style="width:100%;height:100%;"
            ref="videoPlayer"
            name="videoPlayer"
            id="video"
            :playsinline="true"
            :options="playerOptions"
        >
        </video-player>
        <img v-else-if="previewList[pointerIndex].type.indexOf('image/')>-1" :src="previewList[pointerIndex].url"/>
        <iframe v-else-if="previewList[pointerIndex].icontype==='pdf'" width="100%" height="100%" :src="previewList[pointerIndex].url"></iframe>
        <iframe v-else-if="previewList[pointerIndex].icontype!=='pdf'&&previewUrl" width="100%" height="100%" :src="previewUrl"></iframe>
        <div class="tip" v-else>暂不支持当前格式文件预览，请下载到本地查看</div>
        <template v-if="isMouseMove">
            <img class="btn-left" src="../../assets//images/digital/preview-left.png" @click="onPrev" />
            <img class="btn-right" src="../../assets//images/digital/preview-right.png" @click="onNext" />
        </template>
    </div>
</template>

<script>
import { videoPlayer } from 'vue-video-player'
export default {
    name: "PreviewDialog",
    components: { videoPlayer },
    props: {
        currIndex: {
            //当前选中
            type: Number,
        },
        previewList: {
            //预览列表
            type: Array,
        },
    },
    data() {
        return {
            pointerIndex: this.currIndex,
            playTime:'',
            current:'',
            isMouseMove: true,
            timer: null,
            previewUrl: ''
        }
    },
    mounted() {
        this.checkUrl()
        this.onMouseMove()
    },
    computed: {
        playerOptions: function() {
            return {
                playbackRates: [0.5, 1.0, 1.5, 2.0], // 可选的播放速度
                autoplay: false, // 如果为true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 是否视频一结束就重新开始。
                preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: "zh-CN",
                aspectRatio: "4:3", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [
                    {
                        type: this.previewList[this.pointerIndex].type, // 类型
                        src: this.previewList[this.pointerIndex].url // url地址
                    }
                ],
                poster: "", // 封面地址
                notSupportedMessage: "此视频暂无法播放，请稍后再试", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                    timeDivider: true, // 当前时间和持续时间的分隔符
                    durationDisplay: true, // 显示持续时间
                    remainingTimeDisplay: false, // 是否显示剩余时间功能
                    fullscreenToggle: true // 是否显示全屏按钮
                },
            }
        }
    },
    watch: {
        pointerIndex() {
            this.checkUrl()
        }
    },
    methods: {
        handleClose() {
            this.$parent.handleClosePreview()
        },
        //判断是否需要获取预览地址
        checkUrl() {
            let data = this.previewList[this.pointerIndex]
            if(data.type.indexOf('image/')<=-1 && data.type.indexOf('video/')<=-1 && data.icontype!=='pdf') {
                this.getPreviewUrlAxios(data.id)
            }
        },
        //获取预览地址
        getPreviewUrlAxios(fileid) {
            let url = `${window.pubilc_config.digitalServerurl}/v1/digital/filemgt/preview`
            this.$common.getTokenRequest()
                .get(url + '?file=' + fileid)
                .then(res => {
                    if (res.status === 200) {
                        let data = res.data;
                        if(data.code === 0) {
                            this.previewUrl = data.data.url
                        }
                    }
                }).catch(err=>{
                    console.log(err,'===/v1/digital/filemgt/preview')
                })
        },
        //下载
        handleDownload() {
            let current = this.previewList[this.pointerIndex]
            if(current.type.indexOf('image/')>-1) {
                this.$common.downloadIamge(current.url, current.name)
            } else {
                this.$axios
                .get(current.url, {responseType: 'blob'})
                .then(res => {
                if (res.status === 200) {
                    this.$common.downloadFileStream(res.data, current.name)
                }
                }).catch(err=>{
                console.log(err,'下载失败')
                })
            }
        },
        onPrev() {
            this.pointerIndex--;
            if(this.pointerIndex < 0) {
                this.pointerIndex = 0
            }
        },
        onNext() {
            this.pointerIndex++;
            if(this.pointerIndex > this.previewList.length-1) {
                this.pointerIndex = this.previewList.length-1
            }
        },
        //监测鼠标是否移动
        onMouseMove() {
            window.onmousemove = () => {
                this.isMouseMove = true;
                clearTimeout(this.timer);
                this.timer = setTimeout(() => {
                    this.isMouseMove = false;
                }, 2000);
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.preview-dialog {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    background: #fff;
    z-index: 11;
    .preview-title {
        position: absolute;
        top: 30px;
        left: 30px;
        font-size: 24px;
        font-family: SourceHanSansCN-Bold;
        font-weight: bold;
        color: #424242;
        z-index: 1;
    }
    .preview-operate-btn {
        position: absolute;
        width: 270px;
        height: 48px;
        top: 20px;
        right: 20px;
        display: flex;
        justify-content: space-between;
        z-index: 1;
        .btn {
            width: 124px;
            height: 100%;
            color: #fff;
            font-size: 20px;
            font-family: SourceHanSansCN;
            font-weight: 400;
            background: #2899FF;
            border: none;
            border-radius: 2px;
            &:last-child{
                background: #232323;
            }
        }
    }
    img {
        width: 100%;
        height: 100%;
    }
    .html {
        width: 100%;
        height: 100vh;
        overflow: auto;
        color: #000;
        padding: 50px 0 0 10px;
        td {
            border: 1px solid #424242;
        }
    }
    .tip {
        color: #232323;
        font-size: 18px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
    .btn-left {
        position: absolute;
        width: 124px;
        height: 124px;
        left: 20px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
    }
    .btn-right {
        position: absolute;
        width: 124px;
        height: 124px;
        right: 20px;
        top: 50%;
        transform: translateY(-50%);
        cursor: pointer;
    }
}
</style>
<style lang="scss">
// 滚动条的宽度
.html::-webkit-scrollbar {
    width: 8px; // 横向滚动条
    height: 8px; // 纵向滚动条
}
// 滚动条的滑块轨道
.html::-webkit-scrollbar-track-piece {
    background-color: rgb(221, 225, 235);
}
// 滚动条的滑块
.html::-webkit-scrollbar-thumb {
    background-color: #414C65;
    border-radius: 3px;
}
.vjs-custom-skin > .video-js > video {
    object-fit: fill;//消除留白
}
/*播放按钮设置成宽高一致，圆形，居中*/
.vjs-custom-skin > .video-js .vjs-big-play-button {
    background-color: rgba(255,255,255,0);
    font-size: 60px !important;
    border-radius: 50%;
    height: 120px !important;
    line-height: 120px !important;
    border-width: 6px;
    width: 120px !important;
    outline: none;
}
.video-js .vjs-big-play-button .vjs-icon-placeholder:before {
  position: absolute;
  left: 2px;
  top: -6px !important;
}
/*鼠标进入播放器后，播放按钮颜色会变*/
.video-js:hover .vjs-big-play-button, .vjs-custom-skin>.video-js .vjs-big-play-button:active, .vjs-custom-skin>.video-js .vjs-big-play-button:focus{
  background-color: rgba(255,255,255,0) !important;
}
//播放控制栏
.video-js .vjs-control-bar {
    bottom: 18px !important;
}
.video-js .vjs-play-control .vjs-icon-placeholder:before {
    position: absolute;
    left: 0;
    top: 0 !important;
}
/*点击按钮时不显示蓝色边框*/
.video-js .vjs-control-bar button{
  outline: none;
}
.vjs-custom-skin > .video-js .vjs-control-bar .vjs-time-control {
    margin-top: 0 !important;
}
/*进度条滑块大小*/
.video-js .vjs-play-progress:before {
    font-size: 16px!important;
}
</style>